import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './content-list-with-category.component.scss';
import * as Swiper from 'swiper/dist/js/swiper.js';
var ContentListWithCategory = /** @class */ (function (_super) {
    tslib_1.__extends(ContentListWithCategory, _super);
    function ContentListWithCategory(element) {
        return _super.call(this, element) || this;
    }
    ContentListWithCategory.prototype.init = function () {
        this.containerChips = this.element.querySelector('.content-list-with-category__chips');
        this.containerDescription = this.element.querySelector('.content-list-with-category__description');
        this.containerSlider = this.element.querySelector('.content-list-with-category__swiper');
        this.sliderPagination = this.element.querySelector('.slider__pagination');
        this.sliderNext = this.element.querySelector('.slider__nav--next');
        this.sliderPrev = this.element.querySelector('.slider__nav--prev');
        this.varSliderCreated = false;
        this.localStoragePbbIndex = Number(sessionStorage.getItem('activeChipIndex'));
        this.createCategories();
    };
    ContentListWithCategory.prototype.bindEvents = function () {
    };
    // extending functionality for PPB 'southafrica/personal'
    ContentListWithCategory.prototype.chipActiveStateCheck = function () {
        window.addEventListener('DOMContentLoaded', function (event) {
            var navigationEntries = (window.performance &&
                typeof window.performance.getEntriesByType === 'function')
                ? window.performance.getEntriesByType('navigation')
                : [];
            var navEntry = navigationEntries.length > 0 ? navigationEntries[0] : null;
            var isBackOrForward = navEntry && navEntry.type === 'back_forward';
            var isReload = navEntry && navEntry.type === 'reload';
            var activeChipIndex = sessionStorage.getItem('activeChipIndex');
            var chips = document.querySelectorAll('.content-list-with-category__chips--item');
            // UAT testing link to change to southafrica/personal
            var ppbPath = '/southafrica/personal';
            function chipClickHandler(event) {
                sessionStorage.setItem('activeChipIndex', Array.from(chips).indexOf(event.currentTarget));
            }
            chips.forEach(function (chip) {
                chip.removeEventListener('click', chipClickHandler);
            });
            chips.forEach(function (chip) {
                chip.addEventListener('click', chipClickHandler);
            });
            // execute if back or forward/reload button and if PPB
            if (isBackOrForward && window.location.pathname === ppbPath && activeChipIndex !== null || isReload && window.location.pathname && activeChipIndex !== null) {
                chips.forEach(function (chip) { return chip.classList.remove('active'); });
                if (activeChipIndex !== null) {
                    chips.forEach(function (chip) { return chip.classList.remove('active'); });
                    var activeChip = chips[activeChipIndex];
                    activeChip.click();
                }
            }
            else {
                chips[0].classList.add('active');
            }
            // end PPB check
        });
    };
    ContentListWithCategory.prototype.createCategories = function () {
        var _this = this;
        var output = "";
        var index = 0;
        jsonDataContentListWithCategory.forEach(function (category) {
            var iconPath = category.icon; // Full icon path
            var pathParts = iconPath.split('/'); // Split the path into parts
            var iconNameWithExt = pathParts[pathParts.length - 1];
            var iconName = iconNameWithExt.replace('.svg', '');
            // Set the path as everything before icon name
            var dataPath = pathParts.slice(0, pathParts.length - 1).join('/') + '/';
            // Check if the icon path does not start with '/assets'
            // if (!iconPath.startsWith('/assets')) {
            // 	dataPath = '/static_file' + dataPath;  // Prepend '/file_source' to the path
            // }
            if (index === 0) {
                output += "<div class=\"content-list-with-category__chips--item active\" data-index=\"" + index + "\">\n\t\t\t\t\t\t<div class=\"content-list-with-category__chips--item__icon\">\n\t\t\t\t\t\t\t\t<i data-component=\"icon\"\n\t\t\t\t\t\t\t\t\tdata-icon=\"" + iconName + "\"\n\t\t\t\t\t\t\t\t\tdata-path=\"/assets/icons/\"\n\t\t\t\t\t\t\t\t\tclass=\"icon js-content-list-with-category-icon\">\n\t\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"bodyTextSmall content-list-with-category__chips--item__text\">" + category.name + "</div>\n\t\t\t\t\t</div>";
                _this.containerDescription.innerHTML = category.description;
            }
            else {
                output += "<div class=\"content-list-with-category__chips--item\" data-index=\"" + index + "\">\n\t\t\t\t\t\t<div class=\"content-list-with-category__chips--item__icon\">\n\t\t\t\t\t\t\t<i data-component=\"icon\"\n\t\t\t\t\t\t\t\t\tdata-icon=\"" + iconName + "\"\n\t\t\t\t\t\t\t\t\tdata-path=\"/assets/icons/\"\n\t\t\t\t\t\t\t\t\tclass=\"icon js-content-list-with-category-icon\">\n\t\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"bodyTextSmall content-list-with-category__chips--item__text\">" + category.name + "</div>\n\t\t\t\t\t</div>";
            }
            index++;
        });
        this.containerChips.innerHTML = output;
        this.chipActiveStateCheck();
        this.createSliderItems(jsonDataContentListWithCategory[0].items);
        this.createCategoryClick();
        this.setupIcons();
    };
    ContentListWithCategory.prototype.createCategoryClick = function () {
        var _this = this;
        var chips = Array.from(this.containerChips.querySelectorAll('.content-list-with-category__chips--item'));
        chips.map(function (chip) { return chip.addEventListener('click', function (event) {
            chips.forEach(function (chip) {
                chip.classList.remove('active');
            });
            chip.classList.add('active');
            var indexChip = chip.getAttribute('data-index');
            _this.createSliderItems(jsonDataContentListWithCategory[parseInt(indexChip)].items);
            _this.containerDescription.innerHTML = jsonDataContentListWithCategory[parseInt(indexChip)].description;
        }); });
    };
    ContentListWithCategory.prototype.createSliderItems = function (items) {
        if (items === void 0) { items = []; }
        var output = "";
        var index = 0;
        items.forEach(function (item) {
            output += "<div class=\"swiper-slide\">\n\t\t\t\t\t<div class=\"content-list-with-category__item ui-kit__palette--shadow\">\n\t\t\t\t\t\t<div class=\"content-list-with-category__item--image\">\n\t\t\t\t\t\t\t<picture>\n\t\t\t\t\t\t\t\t<source srcset=\"" + item.images.desktop + "\" media=\"(min-width: 1024px)\">\n\t\t\t\t\t\t\t\t<source srcset=\"" + item.images.tablet + "\" media=\"(min-width: 768px)\">\n\t\t\t\t\t\t\t\t<img class=\"responsive-image " + item.images.modifiers + "\" src=\"" + item.images.desktop + "\" srcset=\"" + item.images.mobile + "\" alt=\"\">\n\t\t\t\t\t\t\t</picture>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"title title--module-sub-title content-list-with-category__item--title\">" + item.title + "</div>\n\t\t\t\t\t\t<div class=\"bodyText content-list-with-category__item--description\">" + item.description + "</div>\n\t\t\t\t\t\t<div class=\"content-list-with-category__item--link\">\n\t\t\t\t\t\t\t<a href=\"" + item.link.url + "\" class=\"link\" data-id=\"" + item.link.dataid + "\" data-scope=\"" + item.link.datascope + "\" data-intent=\"" + item.link.dataintent + "\" data-text=\"" + item.link.datatext + "\"><span class=\"link__text\">" + item.link.text + "</span></a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>";
            index++;
        });
        var container = this.containerSlider.querySelector('.js-cards');
        container.innerHTML = output;
        this.createSlider();
    };
    ContentListWithCategory.prototype.createSlider = function () {
        var _this = this;
        if (!this.varSliderCreated) {
            this.varSliderCreated = true;
        }
        else {
            this.slider.destroy();
        }
        var itemsCount = this.containerSlider.querySelectorAll('.swiper-slide').length;
        var slidesPerView = 3; // Default to 3 items per view
        // If there are 4 or more items, enable pagination and slider navigation
        if (itemsCount >= 4) {
            this.sliderPagination.style.display = 'inline-block';
            this.sliderNext.style.display = 'inline-block';
            this.sliderPrev.style.display = 'inline-block';
        }
        else {
            // Hide pagination/navigation controls when there are fewer than 4 items
            this.sliderPagination.style.display = 'none';
            this.sliderNext.style.display = 'none';
            this.sliderPrev.style.display = 'none';
        }
        // Set the number of slides per view depending on the number of items
        if (itemsCount === 1) {
            slidesPerView = 1;
            this.containerSlider.querySelector('.swiper-slide').classList.add('single-item');
        }
        else if (itemsCount === 2) {
            slidesPerView = 2;
        }
        else if (itemsCount === 3) {
            slidesPerView = 3;
        }
        else if (itemsCount >= 4) {
            slidesPerView = 3;
        }
        this.slider = new Swiper(this.containerSlider, {
            slidesPerView: slidesPerView,
            centeredSlides: false,
            spaceBetween: 30,
            initialSlide: 0,
            breakpoints: {
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                1024: {
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                },
                767: {
                    slidesPerView: 1.3,
                    spaceBetween: 30,
                },
                580: {
                    slidesPerView: 1.1,
                    spaceBetween: 10,
                }
            },
            freeMode: false,
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            },
        });
        // Add resize listener to ensure proper layout when resizing
        window.addEventListener('resize', function () {
            _this.slider.update();
        });
    };
    ContentListWithCategory.prototype.setupIcons = function () {
        var _this = this;
        var icons = Array.from(document.querySelectorAll('.js-content-list-with-category-icon'));
        icons.forEach(function (icon) {
            var dataIcon = icon.getAttribute('data-icon');
            var dataPath = icon.getAttribute('data-path');
            if (dataIcon) {
                _this.getIcon(icon, dataIcon, dataPath);
            }
        });
    };
    ContentListWithCategory.prototype.getIcon = function (container, icon, path) {
        if (container === void 0) { container = undefined; }
        if (icon === void 0) { icon = ''; }
        if (path === void 0) { path = ''; }
        var iconUrl = "/file_source" + path + icon + ".svg";
        // const iconUrl = `${path}${icon}.svg`;  
        this.http.get(iconUrl).then(function (response) {
            container.innerHTML = response.data; // Set the SVG content in the icon container
        });
    };
    return ContentListWithCategory;
}(Base));
export { ContentListWithCategory };



//////////////////
// WEBPACK FOOTER
// ./components/content-list-with-category/content-list-with-category.component.ts
// module id = 739
// module chunks = 0